import { gql } from '@apollo/client';
import { Case, Default, Switch } from 'react-if';

import {
  CreditFactorTradeline,
  CreditFactorTradelineSection,
} from '@generated-gql/generated-types';
import classes from '@nerdwallet/base-styles/classes';
import { Box } from '@nerdwallet/currency/components/Box';
import { Text } from '@nerdwallet/currency/components/Text';

import Collapsible from '../../collapsible';

import TradelineList from '../tradeline-list';
import TradelineSection from '../tradeline-section';

interface Component<E> extends React.FC<E> {
  fragment: any;
}

interface Props {
  TradelineListItem: React.FC<{ tradeline: CreditFactorTradeline }>;
  sections: CreditFactorTradelineSection[];
}

const CollapsibleTradelineSections: Component<Props> = ({
  sections,
  TradelineListItem,
}) => (
  <ul className={classes('width-100')}>
    {sections?.map((section, index) => (
      <Switch key={`tradeline-section-${section?.title}`}>
        <Case condition={section?.isPriority}>
          <TradelineSection
            section={section}
            TradelineListItem={TradelineListItem}
          />
        </Case>
        <Default>
          <Collapsible
            isOpen={!index}
            label={section?.title}
            numItems={section?.tradelines?.length}
          >
            <Box width="100">
              <Text>{section?.subtitle}</Text>
              <TradelineList
                tradelines={section?.tradelines || []}
                TradelineListItem={TradelineListItem}
              />
            </Box>
          </Collapsible>
        </Default>
      </Switch>
    ))}
  </ul>
);

CollapsibleTradelineSections.fragment = gql`
  fragment collapsibleTradelineSectionsFragment on CreditFactorTradelineSection {
    isPriority
    title
    subtitle
    ...tradelineSectionFragment
  }
  ${TradelineSection.fragment}
`;

export default CollapsibleTradelineSections;
